goog.provide("shadow.js.shim.module$$mui$material$ToggleButton");
goog.provide("module$shadow_js_shim_module$$mui$material$ToggleButton");
shadow.js.shim.module$$mui$material$ToggleButton = shadow.js.nativeProvides["@mui/material/ToggleButton"] = shadow$bridge("@mui/material/ToggleButton");
module$shadow_js_shim_module$$mui$material$ToggleButton.default = shadow.js.shim.module$$mui$material$ToggleButton;
